import { store as acl } from "@/modules/acl";
import { store as auth } from "@/modules/auth";
import { store as users } from "@/modules/users";
import { store as areas } from "@/modules/areas";
import { store as categorias } from "@/modules/categorias";
import { store as config } from "@/modules/config";
import { store as estados } from "@/modules/estados";
import { store as municipios } from "@/modules/municipios";
import { store as tipos_instrumentos } from "@/modules/tipos_instrumentos";
import { store as tipos_concedentes } from "@/modules/tipos_concedentes";
import { store as tipos_instituicoes } from "@/modules/tipos_instituicoes";
import { store as moedas } from "@/modules/moedas";
import { store as relatorios } from "@/modules/relatorios";
import { store as oportunidades } from "@/modules/oportunidades";
import { store as parceiros } from "@/modules/parceiros";
import { store as clientes } from "@/modules/clientes";
import { store as assinaturas } from "@/modules/assinaturas";
import { store as planos } from "@/modules/planos";
import { store as pedidos } from "@/modules/pedidos";
import { store as concedentes } from "@/modules/concedentes";
import { store as concedentes_contatos } from "@/modules/concedentes_contatos";
import { store as files } from "@/modules/files";
import { store as contrapartidas } from "@/modules/contrapartidas";
import { store as cnpj } from "@/modules/cnpj";
import { store as extratores } from "@/modules/extratores";
import { store as perfis } from "@/modules/perfis";

export default {
  acl,
  auth,
  users,
  areas,
  categorias,
  config,
  estados,
  municipios,
  tipos_instrumentos,
  tipos_concedentes,
  tipos_instituicoes,
  moedas,
  relatorios,
  oportunidades,
  parceiros,
  clientes,
  assinaturas,
  planos,
  pedidos,
  concedentes,
  concedentes_contatos,
  files,
  contrapartidas,
  cnpj,
  extratores,
  perfis,
};
